import React from "react";
import {useTranslation} from "react-i18next";

export function EventSettingsItem({fieldName, event, setEvent}) {
    const { t } = useTranslation();

    const changeHandler = (val, fieldName) => {
        if(val.match(/^([0-9]{1,})?(\.)?([0-9]{1,})?$/)) {
            const newEntry = {
                ...event,
                [fieldName]: val
            };
            setEvent(newEntry);
        }
    };

    return (
        <div className="col-12 mb-3">
            <div className="d-flex flex-row align-items-center my-1">
                <div>
                    <span>
                        {["rehearsal", "raccord"].includes(fieldName) ? "1 " : ""}
                        {t("events."+fieldName)}
                        </span> =
                </div>
                <div className="ms-3">
                    <input
                        value={event[fieldName]}
                        onChange={val => changeHandler(val.target.value, fieldName)}
                        style={{width: '100%', maxWidth: '83px', textAlign:'right'}}
                        name={"event_"+fieldName}
                    /> h
                </div>
            </div>
        </div>
    )
}